import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';

// Schema for bookmark operations - only needs id
const bookmarkPayloadSchema = t.object({
  id: t.string
});

// Response schema for add operations - includes full bookmark data
const addBookmarkResponseSchema = t.object({
  id: t.string,
  path: t.string,
  label: t.string,
  icon: t.optional(t.string)
});

// Response schema for remove operations - only needs id
const removeBookmarkResponseSchema = t.object({
  id: t.string
});

// Union schema for bookmarkChanged responses
const bookmarkResponseSchema = t.union(addBookmarkResponseSchema, removeBookmarkResponseSchema);
export let BookmarkAction;
(function (BookmarkAction) {
  BookmarkAction["ADD"] = "ADD";
  BookmarkAction["REMOVE"] = "REMOVE";
})(BookmarkAction || (BookmarkAction = {}));
const bookmarkActionSchema = t.union(t.literal(BookmarkAction.ADD), t.literal(BookmarkAction.REMOVE));
const bookmarkChanged = defineMessage({
  type: 'bookmark-changed',
  payloadSchema: t.object({
    action: bookmarkActionSchema,
    success: t.boolean,
    bookmark: bookmarkResponseSchema,
    failureReason: t.optional(t.string)
  })
});
const addBookmark = defineMessage({
  type: 'add-bookmark',
  payloadSchema: bookmarkPayloadSchema,
  reply: bookmarkChanged
});
const removeBookmark = defineMessage({
  type: 'remove-bookmark',
  payloadSchema: bookmarkPayloadSchema,
  reply: bookmarkChanged
});

// Toggles the pinned state of an item. Navigation decides whether the item ends
// up pinned or unpinned; the resulting state is conveyed via the reply's
// `action` (ADD = now pinned, REMOVE = now unpinned).
const toggleBookmark = defineMessage({
  type: 'toggle-bookmark',
  payloadSchema: bookmarkPayloadSchema,
  reply: bookmarkChanged
});
export const bookmarksApi = {
  addBookmark,
  removeBookmark,
  toggleBookmark,
  bookmarkChanged
};